import Papa from "papaparse";
import type { Word } from "./backendTypes";

export async function fetchAndParseCsv(url: string): Promise<Word[]> {
  const response = await fetch(url);
  if (!response.ok) {
    console.error(`Could not connect to ${url} for fetching CSV.`);
  }

  console.log(`Connected to ${url} successfully.`);
  const csvText = await response.text();
  const parsed = Papa.parse(csvText, {
    header: true,
    skipEmptyLines: true,
    dynamicTyping: true,
  });

  return parsed.data as Word[];
}
